import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "../../styles/profile.module.css";
import { GetTokenApi, PostTokenApi } from "../../api/api-service";
import { API_Path, apiBaseUrlImg, baseName } from "../../const";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Loading from "../loader/Loading";
import usePageTitle from "../customHook/usePageTitle";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { allCountrys, errorContainer, formAttr, formAttrAlphabets } from "../common/CommonFun";
import SelectField from "../select_option/SelectField";
import SuccessesImg from "../../assets/images/kyc-verification.svg";
import kYCRejectedImg from "../../assets/images/kyc-rejected.svg";
import KYCFrontImg from "../../assets/images/kyc_front.png";
import KYCBackImg from "../../assets/images/kyc_back.png";
import KYCSuccess from "../../assets/images/success.png";
import KYCSelfieImg from "../../assets/images/kyc_selfie.png";
import upload_img from "../../assets/images/upload_img.svg";
import KYCreviewing from "../../assets/images/reviewing.png";
import { AuthContext } from "../../context/AuthContext";

var KYCData = "";
let isAllowKycComplete = false;
let kycStep = 0;

var IdentityType = [
    { value: "National ID", label: "National ID" },
    { value: "Driver's License", label: "Driver's License" },
    { value: "Passport", label: "Passport" },
];

export default function KYCInfo(props) {
    usePageTitle("User Account", true);
    const Navigate = useNavigate();
    const selectRef = useRef(null);
    const { getCurrentUserDetails } = useContext(AuthContext);
    const [useKycData, setUserKycData] = useState({ ...KYCData });
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedOption, setSelectedOption] = useState("Select country");
    const [selectedName, setSelectedName] = useState("");
    const [fileImg, setFileImg] = useState({
        frontImg: null,
        backImg: null,
        selfieImg: null,
    });
    const [uploadImg, setUploadImg] = useState({
        frontImg: null,
        backImg: null,
        selfieImg: null,
    });
    const [identityOption, setIdentityOption] = useState([]);
    const [BTNLoading, setBTNLoading] = useState(false);
    const [fileError, setFileError] = useState({ flag: false, error: "" });
    const [submitionData, setSubmitionData] = useState(false);

    useEffect(() => {
        // if (!props.apiCalled) {
        setLoading(true);
        getUserKYCDetails();
        // }
        fatchIdentityName();
    }, []);

    const getUserKYCDetails = () => {
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.getUserKyc));
        });
        getCryptoCurrency.then((res) => {
            if (res) {
                if (res.status === 200) {
                    setLoading(false);
                    KYCData = res.data;
                    setUserKycData(KYCData);
                    if (res.data.Id > 0) kycStep = 2;
                    else kycStep = 1;
                    if (KYCData.IsAllowKycComplete) {
                        isAllowKycComplete = true;
                    }
                } else {
                    setLoading(false);
                    toast.error(res.statusText);
                }
            }
        });
    };
    const fatchIdentityName = () => {
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.getIdentityName));
        });
        getCryptoCurrency.then((res) => {
            if (res) setIdentityOption(res.data);
            else toast.error(res.statusText);
        });
    };

    const handleRedirect = () => {
        getUserKYCDetails();
        Navigate("/useraccount/profile/user-kyc-info ");
    };

    const setSubmitData = (formdata, resetForm) => {
        setBTNLoading(true);
        const formData = new FormData();
        // formData.append("SourceLogo", fileImg);
        formData.append("userDocModel", JSON.stringify(formdata));
        formData.append("frontImage", fileImg.frontImg && fileImg.frontImg != undefined && fileImg.frontImg != null ? fileImg.frontImg : null);
        formData.append("backImage", fileImg.backImg && fileImg.backImg != undefined && fileImg.backImg != null ? fileImg.backImg : null);
        formData.append("selfiImage", fileImg.selfieImg && fileImg.selfieImg != undefined && fileImg.selfieImg != null ? fileImg.selfieImg : null);

        let editProfile = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userKYCDocUpload, formData));
        });
        editProfile.then((res) => {
            if (res.data.Isvalid) {
                setBTNLoading(false);
                toast.success(res.data.Successes[0]);
                // getUserKYCProfile();
                // onClick={() => setSubmitionData(!submitionData)}
                setSubmitionData(!submitionData);

                resetForm();
            } else toast.error(res.data.Errors[0]);
            setTimeout(() => {
                setBTNLoading(false);
            }, 6000);
        });
    };
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
            const objectUrl = URL.createObjectURL(file);
            const updatedFileImg = { ...fileImg, [`${type}Img`]: file };
            const updatedUploadImg = { ...uploadImg, [`${type}Img`]: objectUrl };
            setUploadImg(updatedUploadImg);
            setFileImg(updatedFileImg);
        }
    };

    return (
        <React.Fragment>
            {loading && <Loading />}
            <div className={`${styles.personal_info_body}`}>
                {kycStep == 1 && (
                    <div className={`${styles.kyc_alert} ${styles.kyc_alert_info}`}>
                        <span>Please complete the Profile before initiating KYC verification.</span>
                    </div>
                )}
                {kycStep === 2 && (
                    <>
                        {useKycData?.DocStatus === 1 && (
                            <div className="text-center">
                                <div className={`${styles.kyc_reviewing}`}>
                                    <img src={KYCreviewing} alt="" className="img-fluid " />
                                    <div className={styles.kyc_content}>
                                        <div className={styles.title}>
                                            <h6>We Are Reviewing Your KYC</h6>
                                        </div>
                                        <p className="mb-0">Your KYC is under review at {baseName.toLowerCase()}. KYC is instant if the documents are</p>
                                        <p className="mb-0">valid and clearly visible. If not, we have to manually review the documents</p>
                                        <p>and information provided by you. This could take some time.</p>
                                    </div>
                                </div>
                            </div>
                        )}
                        {useKycData?.DocStatus === 2 && (
                            <div className={styles.kyc_congras}>
                                <img src={SuccessesImg} alt="" className="img-fluid " />
                                <div>
                                    <h5>CONGRATULATIONS !</h5>
                                    <p className="mb-0">Your KYC is verified.</p>
                                    <p>You can now use all Coinsbaskets's services at their full.</p>
                                </div>
                            </div>
                        )}
                        {useKycData?.DocStatus === 3 && (
                            <div className={styles.kyc_rejected_box}>
                                <img src={kYCRejectedImg} alt="" className="img-fluid " />
                                <div className={styles.kyc_content}>
                                    <div className={styles.title}>
                                        <h5>KYC Rejected!</h5>
                                    </div>
                                    <p>Sorry! Your KYC application has been rejected.</p>
                                    <p>We request you to retry with valid and clear documents.</p>
                                    <div>
                                        <span>Your KYC has been rejected due to following reason(s):</span>
                                        <ul>
                                            {useKycData?.KycRejectReasons?.map((item, index) => (
                                                <li className={`${styles.kyc_reject_reasons} fw-medium`}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                        {(useKycData?.DocStatus === 0 || useKycData?.DocStatus === 3) && (
                            <div>
                                {submitionData ? (
                                    <div className={`${styles.kyc_success} p-3`}>
                                        <img src={KYCSuccess} alt="" className="img-fluid " />
                                        <div className={styles.title}>
                                            <h6 className="green_color">Complete Submition</h6>
                                        </div>
                                        <div className={styles.kyc_content}>
                                            <h3>
                                                Hey ! Thanks for upload your documents , <br></br> our review team will review your documents and you will get an update.
                                            </h3>
                                            {/* <span>
                                        <bdi>Important :</bdi> You can scan the QR code or request for a SMS link for completing KYC verification on your mobile.
                                    </span> */}
                                            <div className="form-group">
                                                <div className={`${styles.personal_info_btn} text-center d-flex`}>
                                                    <button type="button" className={`${styles.button} ${styles.button_border}`} onClick={handleRedirect}>
                                                        Back To Profile
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card p-3">
                                        <Formik
                                            initialValues={{ IdentityType: "", IdentityNumber: "", FullName: "", selfiImage: "", backImage: "", frontImage: "" }}
                                            validationSchema={Yup.object().shape({
                                                IdentityType: Yup.string().required("Select identity type is required."),
                                                IdentityNumber: Yup.string().required("Identity number is required."),
                                                FullName: Yup.string().required("Full name is required."),
                                                frontImage: Yup.mixed()
                                                    .required("Front image is required.")
                                                    .test("fileSize", "File too large. Max size is 4MB.", (value) => {
                                                        return value && value.size <= 4 * 1024 * 1024; // 4MB in bytes
                                                    })
                                                    .test("fileFormat", "Unsupported file format. Only JPEG/JPG/PNG allowed.", (value) => {
                                                        if (value) {
                                                            const validExtensionRegex = /(\.jpg|\.jpeg|\.png)$/i;
                                                            return validExtensionRegex.test(value.name);
                                                        }
                                                        return false;
                                                    }),
                                                backImage: Yup.mixed()
                                                    .required("Back image is required.")
                                                    .test("fileSize", "File too large. Max size is 4MB.", (value) => {
                                                        return value && value.size <= 4 * 1024 * 1024; // 4MB in bytes
                                                    })
                                                    .test("fileFormat", "Unsupported file format. Only JPEG/JPG/PNG allowed.", (value) => {
                                                        return value && (value.type === "image/jpeg" || value.type === "image/png");
                                                    }),
                                                selfiImage: Yup.mixed()
                                                    .required("Selfie image is required.")
                                                    .test("fileSize", "File too large. Max size is 4MB.", (value) => {
                                                        return value && value.size <= 4 * 1024 * 1024; // 4MB in bytes
                                                    })
                                                    .test("fileFormat", "Unsupported file format. Only JPEG/JPG/PNG allowed.", (value) => {
                                                        return value && (value.type === "image/jpeg" || value.type === "image/png");
                                                    }),
                                            })}
                                            onSubmit={(values, { resetForm }) => {
                                                setSubmitData(values, resetForm);
                                            }}
                                        >
                                            {(runform) => {
                                                const { touched, errors } = runform;
                                                return (
                                                    <Form onSubmit={runform.handleSubmit}>
                                                        <div className={styles.title}>
                                                            <h6>KYC</h6>
                                                        </div>
                                                        <div className={`${styles.kyc_info_box}`}>
                                                            <div>
                                                                <div className={styles.personalinfocontent}>
                                                                    <label>
                                                                        Choose Identity Type <span className={styles.asterisk}>*</span>
                                                                    </label>
                                                                    <div className="comn-input-main">
                                                                        <SelectField
                                                                            value={IdentityType.find((type) => type == runform.values.IdentityType.value)}
                                                                            optionSData={identityOption.map((type) => ({
                                                                                value: type.IdentityType,
                                                                                label: type.IdentityName,
                                                                            }))}
                                                                            placeholder="identity type"
                                                                            onChangeData={(selectedOption) => runform.setFieldValue("IdentityType", selectedOption.value)}
                                                                            name="IdentityType"
                                                                        />
                                                                    </div>
                                                                    {errorContainer(runform, "IdentityType")}
                                                                </div>
                                                                <div className={styles.personalinfocontent}>
                                                                    <label>
                                                                        Upload Document <span className={styles.asterisk}>*</span>
                                                                    </label>
                                                                    <div className={styles.kyc_img_upload}>
                                                                        <div>
                                                                            <div className={styles.upload_kyc_holder}>
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        name="frontImage"
                                                                                        id="file"
                                                                                        className={styles.inputfile}
                                                                                        onChange={(e) => {
                                                                                            runform.setFieldValue("frontImage", e.target.files[0]);
                                                                                            handleFileChange(e, "front");
                                                                                        }}
                                                                                        accept=".png, .jpg, .jpeg"
                                                                                    />
                                                                                    <img
                                                                                        src={
                                                                                            fileImg.frontImg && fileImg.frontImg != undefined && fileImg.frontImg != null
                                                                                                ? uploadImg.frontImg
                                                                                                : KYCFrontImg
                                                                                        }
                                                                                        alt=""
                                                                                        className={`${styles.document_img} img-fluid`}
                                                                                    />
                                                                                </div>
                                                                                <label htmlFor="file" className={styles.choose_file_label}>
                                                                                    <div className={styles.info}>
                                                                                        <img src={upload_img} alt="" />
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                            <div className={styles.kyc_img_title}>
                                                                                <p>Front Image</p>
                                                                            </div>
                                                                            {errorContainer(runform, "frontImage")}
                                                                        </div>
                                                                        <div>
                                                                            <div className={styles.upload_kyc_holder}>
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        name="backImage"
                                                                                        id="backFile"
                                                                                        className={styles.inputfile}
                                                                                        onChange={(e) => {
                                                                                            runform.setFieldValue("backImage", e.target.files[0]);
                                                                                            handleFileChange(e, "back");
                                                                                        }}
                                                                                        accept=".png, .jpg, .jpeg"
                                                                                    />
                                                                                    <img
                                                                                        src={
                                                                                            fileImg.backImg && fileImg.backImg != undefined && fileImg.backImg !== null ? uploadImg.backImg : KYCBackImg
                                                                                        }
                                                                                        alt=""
                                                                                        className={`${styles.document_img} img-fluid`}
                                                                                    />
                                                                                </div>
                                                                                <label htmlFor="backFile" className={styles.choose_file_label}>
                                                                                    <div className={styles.info}>
                                                                                        <img src={upload_img} alt="" />
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                            <div className={styles.kyc_img_title}>
                                                                                <p>Back Image</p>
                                                                            </div>
                                                                            {errorContainer(runform, "backImage")}
                                                                        </div>
                                                                        <div>
                                                                            <div className={styles.upload_kyc_holder}>
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        name="selfiImage"
                                                                                        id="selfieFile"
                                                                                        className={styles.inputfile}
                                                                                        onChange={(e) => {
                                                                                            runform.setFieldValue("selfiImage", e.target.files[0]);
                                                                                            handleFileChange(e, "selfie");
                                                                                        }}
                                                                                        accept=".png, .jpg, .jpeg"
                                                                                    />
                                                                                    <img
                                                                                        src={
                                                                                            fileImg.selfieImg && fileImg.selfieImg != undefined && fileImg.selfieImg !== null
                                                                                                ? uploadImg.selfieImg
                                                                                                : KYCSelfieImg
                                                                                        }
                                                                                        alt=""
                                                                                        className={`${styles.document_img} img-fluid`}
                                                                                    />
                                                                                </div>
                                                                                <label htmlFor="selfieFile" className={styles.choose_file_label}>
                                                                                    <div className={styles.info}>
                                                                                        <img src={upload_img} alt="" />
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                            <div className={styles.kyc_img_title}>
                                                                                <p>Selfie Image</p>
                                                                            </div>
                                                                            {errorContainer(runform, "selfiImage")}
                                                                        </div>
                                                                    </div>
                                                                    {/* {fileError.flag && <span className="error-message">{fileError.error}</span>} */}
                                                                </div>
                                                                <div className={styles.personalinfocontent}>
                                                                    <label>
                                                                        Full Name
                                                                        <span className={styles.asterisk}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="FullName"
                                                                        className={`${styles.form_input}${errors.FullName && touched.FullName ? " input-error" : ""} `}
                                                                        placeholder="Enter your full name"
                                                                        maxLength="60"
                                                                        {...formAttrAlphabets(runform, "FullName")}
                                                                    />
                                                                    {errorContainer(runform, "FullName")}
                                                                </div>
                                                                <div className={styles.personalinfocontent}>
                                                                    <label>
                                                                        Identity Document Number
                                                                        <span className={styles.asterisk}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="IdentityNumber"
                                                                        className={`${styles.form_input}${errors.IdentityNumber && touched.IdentityNumber ? " input-error" : ""}`}
                                                                        placeholder="Enter identity document number"
                                                                        maxLength="20"
                                                                        {...formAttr(runform, "IdentityNumber")}
                                                                    />
                                                                    {errorContainer(runform, "IdentityNumber")}
                                                                </div>
                                                            </div>
                                                            <div className={styles.document_note}>
                                                                <b>Keep the following points in mind before uploading the picture:</b>
                                                                <p>✔ File accepted: JPEG/JPG/PNG (Max size: 4MB)</p>
                                                                <p>✔ Document should be in good condition</p>
                                                                <p>✔ Face must be clearly visible</p>
                                                                <p>✔ Note must have today’s date</p>
                                                            </div>
                                                        </div>

                                                        <div className={`${styles.personal_info_btn} text-center d-flex `}>
                                                            <button type="submit" className={`${styles.button} primary_button`} disabled={BTNLoading}>
                                                                Submit
                                                                {BTNLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </Form>
                                                );
                                            }}
                                        </Formik>
                                    </div>
                                )}
                            </div>
                        )}
                        {/* {isAllowKycComplete && (
                            <div className="form-group">
                                <div className={`${styles.personal_info_btn} text-center d-flex`}>
                                    <button type="button" className={`${styles.button} ${styles.button_border}`} onClick={handleRedirect}>
                                        Go To Profile
                                    </button>
                                    <button type="submit" className={`${styles.button} primary_button`}>
                                        Continue
                                    </button>
                                </div>
                            </div>
                        )} */}
                    </>
                )}
            </div>
        </React.Fragment>
    );
}
